/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".current-acquisition[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}.current-acquisition[_ngcontent-%COMP%]   dx-text-box[_ngcontent-%COMP%]{width:230px}.current-acquisition[_ngcontent-%COMP%]   dx-button[_ngcontent-%COMP%]{padding:8px}"];
export { styles as styles };
